"use client"

import React from 'react';
import { useTheme } from '../layout/ThemeProvider';
import ThemeToggle from './ThemeToggle';

interface ServicePageWrapperProps {
  children: React.ReactNode;
}

/**
 * Componente wrapper para garantir que todas as páginas de serviços
 * respeitem o tema global configurado e incluam o botão de alternância de tema
 */
const ServicePageWrapper = ({ children }: ServicePageWrapperProps) => {
  const { theme } = useTheme();
  
  return (
    <div className={`service-page min-h-screen ${theme === 'dark' ? 'dark-theme' : 'light-theme'} relative`}>
      {children}
      <ThemeToggle showText={true} />
    </div>
  );
};

export default ServicePageWrapper; 